// Stage dimensions, free of browser globals so the settings core (scripts/settings-core.mjs) can import them. `?width` / `?height` override them in a browser.
const query = new URLSearchParams(globalThis.location?.search ?? '')

// export const WIDTH = parseInt(query.get('width') || 896)

// export const HEIGHT = parseInt(query.get('height') || 512)

export const WIDTH = parseInt(query.get('width') || 640)

export const HEIGHT = parseInt(query.get('height') || 360)

export const RATIO = WIDTH / HEIGHT

/** The root frame's origin is the stage centre: a stage point is its canvas pixel minus `(-STAGE_LEFT, -STAGE_TOP)`. */
export const STAGE_LEFT = -WIDTH / 2

export const STAGE_TOP = -HEIGHT / 2
